import type { ISuccessApiResponse } from '@wyz/types';
import { useOnSuccessQuery, UseQueryResult } from '@wyz/utils';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { Matomo } from '~/common/helpers';
import {
  IBaseSearchFormSchema,
  INoResultLocationState,
  ISearchMeta,
} from '~/purchase/types';

type Args = {
  listQuery: UseQueryResult<
    ISuccessApiResponse<unknown[], ISearchMeta>,
    unknown
  >;
  filterQuery: UseQueryResult<unknown[], unknown>;
  searchQuery: IBaseSearchFormSchema | undefined;
};
export const useNoResultRedirect = ({
  listQuery,
  filterQuery,
  searchQuery,
}: Args) => {
  const navigate = useNavigate();
  const checkedListUpdatedAt = useRef<number | undefined>(undefined);

  useOnSuccessQuery(filterQuery, (products) => {
    if (
      !listQuery.isSuccess ||
      checkedListUpdatedAt.current === listQuery.dataUpdatedAt
    ) {
      return;
    }
    checkedListUpdatedAt.current = listQuery.dataUpdatedAt;

    if (products.length > 0 || !searchQuery) {
      return;
    }

    const state: INoResultLocationState = {
      noResult: {
        searchQuery,
        dmsUnavailable: listQuery.data.meta.dmsUnavailable ?? false,
      },
    };
    Matomo.suppressNextPageView();
    void navigate('..', { replace: true, state });
  });
};
